import React from 'react';
import { Link, useParams } from 'react-router-dom';

function ScanDetail() {
  const { scanId } = useParams();
  
  return (
    <div className="authenticated-page">
      <div className="authenticated-page-content">
        <h1 className="authenticated-page-title">Scan Detail</h1>
        <p className="authenticated-page-body">
          This page will display detailed results for scan ID: {scanId}, including ranked stocks,
          filters applied, and comparison tools.
        </p>
        <nav className="authenticated-page-nav">
          <Link to="/scans">← Back to Scans</Link>
          {' | '}
          <Link to="/dashboard">Dashboard</Link>
        </nav>
      </div>
    </div>
  );
}

export default ScanDetail;
